//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commNav from '@/components/nav/index.vue'
import { Dialog } from 'we-vue'
export default {
  components: {
    commNav
  },
  data() {
    return {
      photoUrl: this.$store.state.userInfo.headphoto,
      patientnickname: this.$store.state.userInfo.patientnickname,
      name: this.$store.state.userInfo.patientname,
      phone: this.$store.state.userInfo.telephone,
      sex: this.$store.state.userInfo.sex,
      age: this.$store.state.userInfo.age,
    }
  },
  // 生命周期之挂载完成
  methods: {
    goPath(target){
      if(target == '/myCaseList'){
        this.$router.push({path: target,query: {pd: 1}});
      }else if(target == '/doctorList'){
        this.$router.push({path: target,query: {befrom: 'myOrderList'}});
      }else{
        this.$router.push({path: target});
      }
    },
    boundPhone(){
      if(!this.phone){
        this.$router.push({path: '/boundPhone',query:{form:'myManage'}});
      }
    },
    inits(){
      document.title = '我的管理';
      this.photoUrl = this.$store.state.userInfo.headphoto;
      this.patientnickname = this.$store.state.userInfo.patientnickname;
      this.name = this.$store.state.userInfo.patientname;
      this.phone = this.$store.state.userInfo.telephone;
      this.sex = this.$store.state.userInfo.sex;
    }
  },
  created: function(){
    this.$isLogin(window.location.search.substr(1),this.inits);

  },
}



// WEBPACK FOOTER //
// ./src/views/myManage/index.vue